import { useTranslation } from 'react-i18next';
import type { AdminOverview } from '@b4b/shared';
import type { ReactNode } from 'react';
import { formatUsd } from './format.js';

function Pill({ tone, children }: { tone: 'ok' | 'bad' | 'muted'; children: ReactNode }) {
  const cls =
    tone === 'ok'
      ? 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300'
      : tone === 'bad'
        ? 'bg-red-500/15 text-red-700 dark:text-red-300'
        : 'bg-neutral-200/60 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300';
  return <span className={`inline-flex min-h-[32px] items-center rounded-full px-3 text-xs font-medium ${cls}`}>{children}</span>;
}

export default function StatusRow({
  overview,
  todayCalls,
  todayCost,
}: {
  overview: AdminOverview;
  todayCalls: number;
  todayCost: number;
}) {
  const { t, i18n } = useTranslation();
  const fetchedAt = overview.worker.lastFetchRunAt ? new Date(overview.worker.lastFetchRunAt) : null;
  const ai = overview.aiEnabled;
  return (
    <div className="flex flex-wrap gap-2">
      <Pill tone={overview.worker.lastFetchOk === false ? 'bad' : overview.worker.lastFetchOk ? 'ok' : 'muted'}>
        {t('admin.status.worker')}:{' '}
        {fetchedAt ? new Intl.DateTimeFormat(i18n.language, { dateStyle: 'short', timeStyle: 'short' }).format(fetchedAt) : t('admin.status.never')}
      </Pill>
      <Pill tone={ai.embedding ? 'ok' : 'muted'}>
        {t('admin.status.ai')}: {ai.embedding ? t('admin.status.on') : t('admin.status.off')}
      </Pill>
      <Pill tone="muted">{t('admin.status.today', { calls: todayCalls, cost: formatUsd(todayCost, i18n.language) })}</Pill>
    </div>
  );
}
